import { queryOptions } from '@tanstack/react-query'
import { listBotApiKeys } from '~/features/bots/services'
import { useQueryKeys } from '../hooks'

type ListBotApiKeysQueryProps = Parameters<typeof listBotApiKeys>[0]

export function listBotApiKeysQueryOptions(props: ListBotApiKeysQueryProps) {
  const { listBotApiKeys: listBotApiKeysQueryKey } = useQueryKeys()
  return queryOptions({
    queryKey: listBotApiKeysQueryKey(props.botId),
    queryFn: async () => listBotApiKeys(props),
    meta: {
      suppressError: true,
    },
  })
}
